import { render, staticRenderFns } from "./ThesisCard.vue?vue&type=template&id=75231b6e"
import script from "./ThesisCard.vue?vue&type=script&lang=js"
export * from "./ThesisCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports